document.addEventListener("DOMContentLoaded", (event) => {
	const tickers = document.querySelectorAll(".ticker");

	if (tickers && tickers.length > 0) {
		if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			enabledTicker();
		}
	}

	function enabledTicker() {
		tickers.forEach((ticker) => {
			ticker.setAttribute("data-animated", true);
			const wrapper = ticker.querySelector("&> .kt-inside-inner-col");
			const tickerContent = ticker.querySelector(".wp-block-gallery");
			const tickerFirstInnerContent = ticker.querySelector(".wp-block-gallery figure");
			const numOfTickerItems = tickerContent.querySelectorAll("figure").length;

			const tickerWidth = ticker.getBoundingClientRect().width;
			const tickerFirstInnerContentWidth = tickerFirstInnerContent.getBoundingClientRect().width;
			const totalInnerContentWidth = tickerFirstInnerContentWidth * numOfTickerItems;
			const numOfClones = Math.ceil(tickerWidth / totalInnerContentWidth) ?? 1;

			const tickerInnerContent = Array.from(tickerContent.children);

			const resizeObserver = new ResizeObserver((entries) => {
				for (let entry of entries) {
					if (entry.target === wrapper) {
						const pageWidth = window.innerWidth;
						const wrapperWidth = wrapper.getBoundingClientRect().width();
						console.log(wrapperWidth);
						if (pageWidth) {
							wrapper.style.maxWidth = `${pageWidth}px`;
						}
					}
				}
			});
			// resizeObserver.observe(wrapper);

			for (let i = 0; i <= numOfClones; i++) {
				tickerInnerContent.forEach((figure) => {
					const clonedCopy = figure.cloneNode(true);
					clonedCopy.setAttribute("aria-hidden", true);
					tickerContent.appendChild(clonedCopy);
				});
			}
		});
	}
});
